import promiseClient from 'hub-http/adapters/promiseClient';
import { environmentUrl, hubletApi } from 'hub-http/middlewares/core';
import * as core from 'hub-http/middlewares/core';
// @ts-ignore Untyped module
import * as debug from 'hub-http/middlewares/debug';
import { createStack } from 'hub-http';
import noAuthClient from 'hub-http/clients/noAuthApiClient';
import Env from 'enviro';
import { getHubletAndEnvOverrides, isHubSpotAppDomain } from '../utils/urls';

import type { PromiseClient } from 'hub-http/adapters/promiseClient';

let paymentsClient: PromiseClient | null = null;

const createPaymentsClient = async () => {
  const hostname = window.location.hostname;
  const { hublet: customDomainHubletOverride, env: customDomainEnvOverride } =
    await getHubletAndEnvOverrides(hostname);

  if (customDomainEnvOverride) {
    Env.set('ENV', customDomainEnvOverride);
  }

  const paymentsApi = environmentUrl(
    hubletApi('payments', 'hubspot', customDomainHubletOverride, true)
  );

  const paymentsStack = createStack(
    core.services,
    core.jsonBody,
    core.httpsOnly,
    core.withQuery,
    debug.rewriteUrl,
    debug.enableFailureInjection,
    core.reportOptionsError,
    core.validateStatus,
    core.jsonResponse,
    paymentsApi
  );

  return isHubSpotAppDomain(hostname)
    ? noAuthClient
    : promiseClient(paymentsStack);
};

/** avoid importing getPaymentsClient directly, use withPaymentsClient() HOF instead, to ensure consistent client initialization */
export const getPaymentsClient = async (): Promise<PromiseClient> => {
  if (!paymentsClient) {
    paymentsClient = await createPaymentsClient();
  }

  return paymentsClient;
};

export const withPaymentsClient =
  <Args extends object, Return>(
    callback: (client: PromiseClient, args: Args) => Promise<Return>
  ) =>
  async (args: Args): Promise<Return> => {
    const client = await getPaymentsClient();
    return callback(client, args);
  };
